import { applyOverrides } from "../applyOverrides";
import { applyUrlOverrides } from "../applyUrlOverrides";

export const applyAllOverrides = ({ allPlacements, hrefBasePath, screenSize }) => {
  let finalPlacements = applyOverrides(allPlacements, screenSize);

  if (hrefBasePath) {
    finalPlacements = applyUrlOverrides(finalPlacements, hrefBasePath);
  }

  return finalPlacements;
};
